var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"abc-step d-flex flex-column align-items-center justify-content-center"},[_c('h2',{staticClass:"abc-step__title"},[_vm._v(_vm._s(_vm.stepLetter))]),_c('p',{staticClass:"abc-step__exp"},[_vm._v(_vm._s(_vm.stepExp))])])
}
var staticRenderFns = []

export { render, staticRenderFns }